// Define CollectionSlider web component
class CollectionSlider extends HTMLElement {
  constructor() {
    super();
    this.sliders = [];
    this.swiperInstances = [];
    this.resizeTimer = null;
    this.mobileBreakpoint = 768;
  }

  connectedCallback() {
    if (typeof Swiper !== 'undefined') {
      this.initializeSliders();
      this.setupResizeListener();
    }
  }

  disconnectedCallback() {
    this.destroyAllSliders();
    window.removeEventListener('resize', this.handleResize);
  }

  initializeSliders() {
    const isMobile = window.innerWidth <= this.mobileBreakpoint;
    this.sliders = document.querySelectorAll('.js-flickity-slider');

    if (isMobile) {
      this.sliders.forEach((slider) => {
        slider.classList.add('swiper');

        const cards = slider.querySelectorAll('.featured-collections__card');
        let wrapper = slider.querySelector('.swiper-wrapper');

        if (!wrapper) {
          wrapper = document.createElement('div');
          wrapper.className = 'swiper-wrapper';

          cards.forEach((card) => {
            card.classList.add('swiper-slide');
            wrapper.appendChild(card);
          });

          slider.appendChild(wrapper);
        }

        const swiperInstance = this.initSwiper(slider);
        this.swiperInstances.push(swiperInstance);
      });
    }
  }

  initSwiper(slider) {
    return new Swiper(slider, {
      slidesPerView: 1.65,
      spaceBetween: 0,
      grabCursor: true,
      pagination: {
        el: this.querySelector('.swiper-pagination'),
        clickable: true,
      },
      breakpoints: {
        320: {
          slidesPerView: 1.65,
          spaceBetween: 15,
        },
        480: {
          slidesPerView: 1.65,
          spaceBetween: 15,
        },
        640: {
          slidesPerView: 1.65,
          spaceBetween: 15,
        },
      },
    });
  }

  setupResizeListener() {
    this.handleResize = () => {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => {
        this.handleResizeEvent();
      }, 250);
    };

    window.addEventListener('resize', this.handleResize);
  }

  handleResizeEvent() {
    const currentIsMobile = window.innerWidth <= this.mobileBreakpoint;

    if (currentIsMobile && this.swiperInstances.length === 0) {
      this.initializeSliders();
    } else if (!currentIsMobile && this.swiperInstances.length > 0) {
      this.destroyAllSliders();
    }
  }

  destroyAllSliders() {
    this.swiperInstances.forEach((swiper) => {
      if (swiper && typeof swiper.destroy === 'function') {
        swiper.destroy(true, true);
      }
    });
    this.swiperInstances = [];

    this.sliders.forEach((slider) => {
      slider.classList.remove('swiper');

      const wrapper = slider.querySelector('.swiper-wrapper');
      if (wrapper) {
        const slides = wrapper.querySelectorAll('.swiper-slide');
        slides.forEach((slide) => {
          slide.classList.remove('swiper-slide');
          slider.appendChild(slide);
        });

        if (wrapper.parentNode) {
          wrapper.parentNode.removeChild(wrapper);
        }
      }
    });
  }
}

// Register the web component
if (!customElements.get('collection-slider')) {
  customElements.define('collection-slider', CollectionSlider);
}
